import React from "react";
import TableDataLoader from "../components/TableDataLoader";

const Export = () => {
  return <div>This is export </div>;
};

export default Export;
